
/**
 * Groups an array of items by a key and applies a name to the group.
 * @param arrayToGroup The array of items to group.
 * @param key The key to group by.
 * @param name The name to apply to the group.
 */

export interface GroupedDataModel<T> {
    key: string;
    name: string;
    items: T[];
}

export function GroupByKeyAndApplyName<T>(arrayToGroup: T[], key: (item: T) => string, name: (item: T) => string): { [key: string]: GroupedDataModel<T> } {
    const groupedResult: { [key: string]: GroupedDataModel<T> } = {};

    arrayToGroup.forEach(currentValue => {
        const groupKey = key(currentValue);
        if (!groupedResult[groupKey]) {
            groupedResult[groupKey] = { key: groupKey, name: name(currentValue), items: [] } as GroupedDataModel<T>;
        }
        groupedResult[groupKey].items.push(currentValue);
    });

    return groupedResult;
}

export const truncatedText = (tekst: string, truncateLength: number): string => {
    return tekst?.length > truncateLength
        ? `${tekst.substring(0, truncateLength)}...`
        : tekst;
}
